import { Fade, Grid } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import React, { FunctionComponent } from 'react';
import PageLoader from './PageLoader';

const useStyles = makeStyles({
    loaderContainer: { minHeight: '100vh' },
    loaderItem: { width: '100%' },
    loader: {
        width: '60%',
        margin: '0 auto',
    },
});

const FullScreenLoader: FunctionComponent<React.PropsWithChildren<unknown>> = () => {
    const classes = useStyles();

    return (
        <Fade in>
            <div>
                <Grid
                    container
                    direction="column"
                    justifyContent="center"
                    alignItems="center"
                    className={classes.loaderContainer}
                >
                    <Grid item xs={12} className={classes.loaderItem}>
                        <PageLoader className={classes.loader} />
                    </Grid>
                </Grid>
            </div>
        </Fade>
    );
};

export default FullScreenLoader;
